import React, { FunctionComponent, useState } from "react";
import { Button, ButtonProps } from "@/components/Button";

export type IconSelectorButtonProps = ButtonProps & {
  mainText: string;
  Icon: FunctionComponent;
  selected?: boolean;
};

const IconSelectorButton = ({
  mainText,
  Icon,
  variant,
  selected = false,
  size = "lg",
  ...props
}: IconSelectorButtonProps) => {
  const [isHover, setHover] = useState(false);
  const handleMouseEnter = () => setHover(true);
  const handleMouseLeave = () => setHover(false);
  const color =
    (selected || isHover) && variant === "outline"
      ? "text-gray-700"
      : "text-gray";
  return (
    <Button
      {...props}
      className={`${
        props.className ? props.className + " " : ""
      }h-24 flex w-full border p-1 transition hover:bg-primary-50`}
      size={size}
      variant={variant}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{
        letterSpacing: 0,
        ...(selected && {
          boxShadow: "0 0 0 2px hsl(var(--color-primary)) inset",
        }),
        ...(isHover && {
          boxShadow: "0 0 0 3px hsl(var(--color-primary)) inset",
        }),
      }}
    >
      <div className="flex flex-col items-center justify-center">
        <Icon />
        <p className={`body font-semibold capitalize ${color} mt-2`}>
          {mainText}
        </p>
      </div>
    </Button>
  );
};

export default IconSelectorButton;
